import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Landing from './pages/Landing';
import Private2 from './pages/Private2';
import Spinner from './components/Spinner';

import { ProtectedRoute } from "./protectedRoute";


const App = () => {


    // get esrii default css
    //loadCss();


    return (
        <Router>
            <Switch>
                <Route exact path="/" component={Landing} />
                <ProtectedRoute exact path="/private" component={Private2} />
                <Route path="*" component={() => "404 NOT FOUND"} />
            </Switch>
        </Router>
    );
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js